import React from "react";
import EditIcon from "../.././../../../assets/Icons/Universal/EditIcon.svg";
import DeleteIcon from "../.././../../../assets/Icons/Universal/DeleteIcon.svg";
import Title from "../../../../Universal/Title.component";
const FeeAddedCard = ({
  formType = "yearly",
  data,
  lightBackColor,
  deepBackColor,
  color,
  onEdit,
  onDelete,
}) => {
  const totalAmount = data?.transactions?.reduce((sum, item) => {
    return sum + item.amount;
  }, 0);

  return (
    <div
      className="overflow-hide flex-col align-left justify-start g-05  radius-6 back-white"
      style={{ width: "20rem" }}
    >
      <div className="flex-col align-left justify-start w-full g-1 p-1">
        <div className="flex-row align-center justify-between w-full ">
          <h3 className="t-15 color-textColor weight-500 poppins-medium">
            {formType.toLowerCase() === "yearly"
              ? data?.enrollment
              : data?.subscriptionType}
          </h3>
          <div className="flex-row align-center justify-start g-1">
            <button type="button" onClick={onEdit} className="transparentBtn">
              <img
                src={EditIcon}
                alt="edit button"
                style={{ width: "1.3rem", height: "1.3rem" }}
                loading="lazy"
              />
            </button>
            <button type="button" onClick={onDelete} className="transparentBtn">
              <img
                src={DeleteIcon}
                alt="edit button"
                style={{ width: "1.3rem", height: "1.3rem" }}
                loading="lazy"
              />
            </button>
          </div>
        </div>

        <div className="flex-row align-left justify-start g-05">
          <span className="t-13 poppins color-grayColor">Classes for:</span>
          <div className="flex-row align-left justify-start g-05">
            {data?.classes?.map((item, index) => {
              const isLast = index === data?.classes?.length - 1;
              return (
                <span
                  key={index}
                  className="t-14 poppins"
                  style={{ color: color }}
                >
                  {item}
                  {isLast ? "" : ","}
                </span>
              );
            })}
          </div>
        </div>
      </div>
      <div className="w-full flex-col align-left justify-start">
        <div
          className="w-full flex-col align-left justify-start g-1 p-1"
          style={{ background: lightBackColor }}
        >
          <Title>Services</Title>
          <div className="w-full flex-col align-left justify-start g-05">
            {data?.transactions?.map((trData) => {
              return (
                <div className="flex-row align-center justify-start g-05">
                  <span className="t-13 color-grayColor poppins">
                    {trData?.name} :
                  </span>
                  <span className="t-13 poppins" style={{ color: color }}>
                    ₹ {trData?.amount}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        <div
          className="w-full flex-row align-center justify-start g-05 p-1"
          style={{ background: deepBackColor }}
        >
          <h3 className="t-16 poppins color-textColor weight-500">
            Total fees:
          </h3>
          <span className="t-16 poppins color-textWhite">₹{totalAmount}</span>
        </div>
      </div>
    </div>
  );
};

export default FeeAddedCard;
